import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Company } from '../../company/company.model';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { SelectModule } from 'primeng/select';

interface DashboardCompanyScopeOption {
  label: string;
  value: number | null;
}

@Component({
  selector: 'app-dashboard-company-scope-selector',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IftaLabelModule,
    InputGroupModule,
    InputGroupAddonModule,
    SelectModule
  ],
  template: `
    <section class="dashboard-company-scope-selector">
      <p-inputGroup>
        <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
        <p-iftaLabel>
          <p-select
            inputId="dashboardCompanyScope"
            [options]="options"
            optionLabel="label"
            optionValue="value"
            [ngModel]="selectedCompanyId"
            (ngModelChange)="selectedCompanyIdChange.emit($event)"
            [appendTo]="'body'"
            styleClass="w-full">
          </p-select>
          <label for="dashboardCompanyScope">{{ label }}</label>
        </p-iftaLabel>
      </p-inputGroup>
      <small class="scope-hint" *ngIf="hint">{{ hint }}</small>
    </section>
  `,
  styles: [`
    .dashboard-company-scope-selector {
      display: grid;
      gap: 0.45rem;
      margin-bottom: 1rem;
      padding: 0.9rem 1rem;
      border: 1px solid var(--app-border, #dfe7f3);
      border-radius: 8px;
      background: var(--app-surface, #ffffff);
      box-shadow: 0 10px 24px var(--app-shadow-soft, rgba(15, 23, 42, 0.05));
    }

    .scope-hint {
      color: var(--app-muted, #64748b);
      font-size: 0.82rem;
      font-weight: 600;
    }
  `]
})
export class DashboardCompanyScopeSelectorComponent {
  @Input() label = 'Dashboard company';
  @Input() allCompaniesLabel?: string;
  @Input() hint = 'Group scope stays active. Default view shows all companies in the group.';
  @Input() companyGroupName = '';
  @Input() memberCompanies: Company[] = [];
  @Input() selectedCompanyId: number | null = null;
  @Output() selectedCompanyIdChange = new EventEmitter<number | null>();

  get options(): DashboardCompanyScopeOption[] {
    const allCompaniesLabel = this.allCompaniesLabel || (this.companyGroupName
      ? `${this.companyGroupName} (All companies)`
      : 'All companies in group');
    return [
      { label: allCompaniesLabel, value: null },
      ...this.memberCompanies.map(company => ({
        label: company.name,
        value: company.id
      }))
    ];
  }
}
